module.exports = __webpack_public_path__ + "img/heron.bd12d7aa.png";